// extracted by mini-css-extract-plugin
export default {"header_dark":"Cards_header_dark__miexp","banner":"Cards_banner__8o6MU","card":"Cards_card__vC3Nl","cards":"Cards_cards__M6j7p"};